declare module 'react-native-custom-haptics' {
  const noTypesYet: any;
  export default noTypesYet;
}
